import { useEventListener } from '@vueuse/core';

const CUSTOM_EVENT = 'search-complete';
const HEADER_SELECTOR = '.tutorials-header';

const getHeaderHeight = () => {
    const header = document.querySelector(HEADER_SELECTOR);
    const headerRect = header.getBoundingClientRect();

    return headerRect.height;
};

const scrollToSearchBar = (scrollHeight: number) => {
    window.scrollTo({
        top: scrollHeight,
    });
};

const initializeEventListening = () => {
    const scrollHeight = getHeaderHeight() / 2;

    useEventListener(window, CUSTOM_EVENT, () => scrollToSearchBar(scrollHeight));
};

useEventListener(document, 'DOMContentLoaded', initializeEventListening);
